module.exports = __webpack_public_path__ + "img/xr_resolution.84abd9db.jpg";